import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../hoc/Loading/Loading";
import axios from "../../axios";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import { uploadPreview } from "../../utils/constants";
import moment from "moment";
import * as url from "../../utils/url";
import {
  Card,
  CardBody,
  CardImg,
  CardTitle,
  CardText,
  Input,
  Row,
  Col,
} from "reactstrap";

class TaskFileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachments: this.props.task_copy.attachments,
    };
  }

  getAttachedItems = () => {};

  componentDidMount() {
    // this.getAttachedItems()
  }

  componentDidUpdate(prevProps) {
    let current_att = JSON.stringify(this.props.task_copy.attachments);
    let prev_att = JSON.stringify(prevProps.task_copy.attachments);
    if (current_att != prev_att) {
      this.setState({
        attachments: this.props.task_copy.attachments,
      });
    }
  }

  removeUpoload = itm => {
    let { task_copy } = this.props;
    console.log("url: ", itm);
    let payload = {
      removeItm: itm,
      taskId: task_copy._id,
    };
    let newTask;

    axios.post(url.taskRemoveFiles, payload).then(({ data }) => {
      let result = data.data;
      delete result.parentTask;
      delete result.assignedTo;
      delete result.userId;
      newTask = { ...task_copy, ...result };
      this.props.updateTaskUploads(newTask);
      this.setState({
        attachments: result.attachments,
        isActionsModal: false,
        isResourceSelect: null,
        isUploadFiles: false,
        setImagesPreview: [],
      });
    });
    // this.props.updateTaskUploads(newTask)
  };

  renderView = () => {
    let { task_copy } = this.props;
    let { attachments } = this.state;
    if (attachments) {
      return attachments.map((e, idx) => {
        let { size, url } = e;
        let img = uploadPreview(e);
        let { preview, isMsIcon } = img;
        let mb = 1024 * 1024;
        let file_size =
          size >= mb
            ? `${(size / mb).toFixed(2)}mb`
            : `${(size / 1024).toFixed(2)}kb`;

        return (
          <div
            className="col-lg-4 col-md-4 col-sm-6 col-xs-12"
            key={idx + e.url}
          >
            <Card className="taskAttachmentItmContainer" key={url}>
              <span className="taskAttachmentImgContainer">
                <CardImg
                  alt="..."
                  src={preview}
                  top
                  className="taskAttachmentImg"
                  style={{ height: isMsIcon ? "80px" : null }}
                ></CardImg>
              </span>
              <CardBody className="uploadTaskContainer">
                <CardTitle className="taskAttachmentName">{e.name}</CardTitle>
                <CardText className="ml0">
                  <span className="taskAttachmentContent">
                    <a href={e.url} target="_blank">
                      Download
                    </a>{" "}
                    ({file_size})
                  </span>
                  {this.props.user && this.props.user.profile ? (
                    this.props.user.profile._id.toString() ==
                      (task_copy.assignedTo &&
                        task_copy.assignedTo._id.toString()) ||
                    this.props.user.profile._id ==
                      task_copy.userId._id.toString() ||
                    this.props.user.profile.role == "Admin" ||
                    this.props.user.profile.orgAdmin ? (
                      <span
                        className="taskRemoveAttachment"
                        onClick={() => this.removeUpoload(e.url)}
                      >
                        Remove
                        <span className="flaticon-trash" />
                      </span>
                    ) : null
                  ) : null}
                  <span className="taskAttachmentContent text-muted">
                    Uploaded on {moment(e.uploadDate).format("MMM D, YYYY")}
                  </span>
                </CardText>
              </CardBody>
            </Card>
          </div>
        );
      });
    } else {
      return null;
    }
  };

  render() {
    return (
      <div className="card-deck taskAttachmentContainer">
        {this.renderView()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
  };
};

// export default LinkedCharts;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(TaskFileUpload, axios)));
